import React, { useEffect, useState } from "react";
import {
  FormControlLabel,
  Switch as MuiSwitch,
  SwitchProps,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import { colors } from "theme";

const useStyles = makeStyles(() => ({
  root: {
    padding: 0,
    width: 70,
    height: 20,
    borderRadius: 10,
    "&.checked + .MuiFormControlLabel-label:not(.Mui-disabled)": {
      color: colors.violet[500],
    },
  },
  base: {
    padding: 0,
    color: colors.nero[300],
    "&.Mui-checked": {
      transform: "translateX(50px)",
    },
    "&.Mui-disabled": {
      display: "none",
    },
  },
  track: {
    backgroundColor: colors.white,
    opacity: 1,
  },
  colorPrimary: {
    "&.Mui-checked + .MuiSwitch-track": {
      background: colors.white,
      opacity: 1,
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      background: colors.semantic.neutral,
      opacity: 1,
    },
  },
  colorSecondary: {
    "&.Mui-checked": {
      color: colors.ocean[600],
    },
    "&.Mui-checked + .MuiSwitch-track": {
      background: "#8AAED0",
    },
  },
  labelRoot: {
    position: "relative",
  },
  label: {
    position: "absolute",
    top: 1,
    left: 0,
    right: 0,
    fontSize: 12,
    lineHeight: 1.5,
    textAlign: "center",
    color: colors.nero[300],
    "&.Mui-disabled": {
      color: `${colors.grey[600]} !important`,
    },
  },
}));

const Switch = (props: SwitchProps & { label?: string }) => {
  const [checked, setChecked] = useState<boolean>(props.checked || false);
  const classes = useStyles();

  useEffect(() => {
    setChecked(props.checked || false);
  }, [props.checked]);

  return (
    <FormControlLabel
      control={
        <MuiSwitch
          classes={{
            root: classes.root,
            switchBase: classes.base,
            colorPrimary: classes.colorPrimary,
            colorSecondary: classes.colorSecondary,
            track: classes.track,
          }}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setChecked(event.target.checked)
          }
          color="primary"
          className={checked ? "checked" : ""}
          {...props}
          checked={checked}
        />
      }
      label={props.label ?? (checked ? "Yes" : "No")}
      classes={{
        root: classes.labelRoot,
        label: classes.label,
      }}
    />
  );
};

export default Switch;
